import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const assignAdoptionPlayerActionTypes = {
  ADD: type('[Adoption Device] Add'),
  ADD_SUBSCRIPTION: type('[Adoption Device Subscription] Add'),
  ADD_SUCCESS: type('[Adoption Device] Add Success'),
  ADD_FAIL: type('[Adoption Device] Add Fail')
};

export class AssignAdoptionPlayerAction implements Action {
  readonly type = assignAdoptionPlayerActionTypes.ADD;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}
export class AssignAdoptionSubscriptionPlayerAction implements Action {
  readonly type = assignAdoptionPlayerActionTypes.ADD_SUBSCRIPTION;
  // tslint:disable-next-line:no-any
  constructor(public payload?: {
    subscriptionUuid: string,
    code: string,
    concepts: string[],
    isDefault: boolean,
    bsnProductModel: string,
    family: string }) {}
}

export class AssignAdoptionPlayerSuccessAction implements Action {
  readonly type = assignAdoptionPlayerActionTypes.ADD_SUCCESS;
  constructor() {}
}

export class AssignAdoptionPlayerFailAction implements Action {
  readonly type = assignAdoptionPlayerActionTypes.ADD_FAIL;
  constructor(public payload?: string) {}
}
